export default {
  // 深拷贝
  deepClone (obj) {
    console.log("输出结构", obj)
    let result
    if (typeof obj !== 'object' || obj === null) {
      return obj
    }
    // 判断是对象还是数组
    if (obj instanceof Array) {
      result = []
    } else {
      result = {}
    }
    for (let key in obj) {
      // 保证key不是原型上的属性
      if (obj.hasOwnProperty(key)) {
        // 递归调用
        result[key] = this.deepClone(obj[key])
      }
    }
    return result
  },
  // 深拷贝
  toArray (obj) {
    // console.log("进入结构", obj)
    let result = []
    if (typeof obj !== 'object' || obj === null) {
      return obj
    }
    for (let key in obj) {
      // 保证key不是原型上的属性
      if (obj.hasOwnProperty(key)) {
        // 递归调用
        result.push({
          "key": key,
          "value": obj[key]
        });
      }
    }
    // console.log("输出结构", obj)
    return result
  },
  //时间戳转换日期
  formatDate(timestamp,type) {
    console.log('入参：',timestamp)
    if (timestamp === 'object' || timestamp == "") {
      return timestamp
    }
    //把时间放到Date的括号里
    let time = timestamp.toString().length > 10? timestamp : timestamp* 1000
    var date = new Date(time);
    var Y = date.getFullYear();
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
    var D = date. getDate()<10?('0'+date.getDate()):date.getDate();
    var h = date.getHours()<10?(('0'+date.getHours())):(date.getHours());
    var m = date.getMinutes()<10?(('0'+date.getMinutes())):(date.getMinutes());
    var s = date.getSeconds()<10?('0'+date.getSeconds()):date.getSeconds();
    let res
    if(type == "yyyy-mm-dd hh:MM:ss"){
      res = Y+'-'+M+'-'+D+' '+h+':'+m+':'+s;
    }else if(type == "yyyy-mm-dd"){
      console.log("sssssss")
      res = Y+'-'+M+'-'+D;
    }else if(type == "hh:MM:ss"){
      res = h+':'+m+':'+s;
    }else if(type == "hh:MM"){
      res = h+':'+m;
    }else if(type == "mm-dd"){
      res = M+'-'+D;
    }else{
      res = Y+'-'+M+'-'+D+' '+h+':'+m+':'+s;
    }
    console.log('结果：',res)
    return res
  }
}



// WEBPACK FOOTER //
// ./src/common/util.js